import { memo, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useToast } from '../../hooks';
import { useAcceptTeamInvitation } from '@travelity/api';

const AcceptTeamInvitation = () => {
    const navigate = useNavigate();
    const { key } = useParams();

    const { showError, showSuccess } = useToast();

    const { mutate: accept } = useAcceptTeamInvitation({
        onSuccess: () => {
            navigate('/events');
            showSuccess('JOIN_TEAM_SUCCESS');
        },
        onError: () => {
            navigate('/events');
            showError('JOIN_TEAM_FAILURE');
        },
        retry: false,
    });

    useEffect(() => {
        if (key) {
            const t = setTimeout(() => accept({ key }), 1);
            return () => clearTimeout(t);
        }
        return () => null;
    }, [key]);

    return null;

    // return teamId && key ? (
    //     <ConfirmationDialog
    //         title={
    //             <Stack direction="row" gap={1} alignItems="center">
    //                 <Warning color="warning" />
    //                 Warning
    //             </Stack>
    //         }
    //         content="If the invitation you are accepting is for an Enterprise team, then all your current memberships will be discarded."
    //         confirmText="Confirm"
    //         open
    //         handleCancel={() => {
    //             navigate('/events');
    //         }}
    //         handleConfirm={() => {
    //             accept({ key });
    //         }}
    //     />
    // ) : null;
};

export default memo(AcceptTeamInvitation);
